import React, { useState, useEffect } from "react"
import axios from "axios"


// GlobalProvider
import { useGlobal, useGlobalUpdate } from "./contexts/GlobalContext";

// Routing
import { Routes, Route, Navigate } from "react-router-dom";




//////////////////////// 
// Unprotected routes
////////////////////////

// // Core routes
import IndexPage from "./pages";
import LoginPage from "./pages/login";
import SignupPage from "./pages/signup/index";
// import ValidateEmailPage from "./pages/validate-email";
// import SetPasswordPage from "./pages/set-password";
// import ResetPage from "./pages/reset";

// // Unprotected OAuth routes
// import OAuthGooglePage from "./pages/oauth/google";



//////////////////////// 
// Protected routes
////////////////////////
import DashboardPage from "./pages/dashboard";

// Dashboard pages


// HOME
import HomePage from "./pages/dashboard/home";

// DISCOVER
import DiscoverPage from "./pages/dashboard/discover";

// KPA1
import KPA1Page from "./pages/dashboard/kpa1";

// TEST
import TestPage from "./pages/dashboard/test";



//////////////////////// 
// Universal routes
////////////////////////


import TermsPage from "./pages/terms";
import PrivacyPage from "./pages/privacy";

import Custom404 from "./pages/404";






// Layouts
import ProtectedLayout from "./layouts/ProtectedLayout";
import UnprotectedLayout from "./layouts/UnprotectedLayout";

// Miscellaneous pages
import SessionUncheckedPage from "./pages/misc/SessionUncheckedPage";

// CSS
import "./App.css";

// IDB
import { get as idb_get, set as idb_set, del as idb_delete } from 'idb-keyval'


// Client environment
import { browserName, isMobile, isDesktop } from "react-device-detect";










const App = () => {

  // Global context
  const global_context = useGlobal()
  const global_update = useGlobalUpdate()

  // States


  

  // Token verified
  const [session_is_checked, set_session_is_checked] = useState(false)


  const set_to_authenticated = async (user_id) => {
    // Set global vars to authenticated
    global_update({
      ...global_context, 
      authenticated: true,
      user_id: user_id,
    })

    return
  }

  const set_to_unauthenticated = async () => {
    // Set session_token to UNSET
    await idb_set("session_token", "UNSET")

    // Set global vars to unauthenticated
    global_update({
      ...global_context,
      authenticated: false,
      user_id: "UNSET",
    })

    return
  }

  // Check token for authenticated state
  const check_session = async () => {

    const session_token = await idb_get("session_token")

    if (!session_token || session_token.startsWith("UNSET")) {
      // Trigger cookie reset to UNSET
      await axios.delete(`/api/auth`)

      // Set to logged out
      await set_to_unauthenticated()
      set_session_is_checked(true)

      // End of the line
      return
    }

    const get_auth_res = await axios.get(`/api/auth`, {
      headers: {
        'Authorization': `session_token=${session_token}`
      }
    });

    if (!get_auth_res.data.success) {
      alert("Fatal error")

      await set_to_unauthenticated()
      set_session_is_checked(true)

      // End of the line
      return
    }

    if (get_auth_res.data.authenticated) {
      await set_to_authenticated(get_auth_res.data.user_id)
      set_session_is_checked(true)

      // End of the line
      return
    } 
    else {
      await set_to_unauthenticated()
      set_session_is_checked(true)

      // End of the line
      return
    }
  }



  // Upon load
  useEffect(() => {

    // Check session
    check_session()

  }, [])

  return (
    session_is_checked
    ? <Routes>

        {/* Unprotected routes */}
        <Route element={<UnprotectedLayout />}>

          {/* Core routes */}
          <Route path="/" element={<IndexPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="signup" element={<SignupPage />} />
          {/* <Route path="validate-email" element={<ValidateEmailPage />} />
          <Route path="set-password" element={<SetPasswordPage />} />
          <Route path="reset" element={<ResetPage />} /> */}

          {/* Unprotected OAuth routes */}
          {/* <Route path="/oauth/google" element={<OAuthGooglePage />} /> */}
          

        </Route>

        {/* Protected routes */}
        <Route element={<ProtectedLayout />}>

          {/* Dashboard routes */}
          <Route path="dashboard" element={<DashboardPage />}>
            <Route index element={<Navigate to={"home"} />} />

            {/* Privileged paths only available to admins & owner */}


            {/* HOME */}
            <Route path="home" element={<HomePage />} />

            {/* DISCOVER */}
            <Route path="discover" element={<DiscoverPage />} />

            {/* KPA1 */}
            <Route path="kpa1" element={<KPA1Page />} />

            {/* TEST */}
            <Route path="test" element={<TestPage />} />
            
            
            
          </Route>


        </Route>

        {/* Universal routes */}

        <Route path="terms" element={<TermsPage />} />
        <Route path="privacy" element={<PrivacyPage />} />



        <Route path="*" element={<Custom404 />} />



      </Routes>
    : <SessionUncheckedPage />
  );
}

export default App;
